"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailMergeOptions = void 0;
var MailMergeOptions = (function () {
    function MailMergeOptions() {
        this.isEnabled = false;
        this.viewMergedData = false;
        this.activeRecordIndex = 0;
        this.recordCount = 0;
        this.allowInsertFields = false;
    }
    MailMergeOptions.prototype.copyFrom = function (obj) {
        this.isEnabled = obj.isEnabled;
        this.viewMergedData = obj.viewMergedData;
        this.activeRecordIndex = obj.activeRecordIndex;
        this.recordCount = obj.recordCount;
        this.allowInsertFields = obj.allowInsertFields;
    };
    MailMergeOptions.prototype.clone = function () {
        var result = new MailMergeOptions();
        result.copyFrom(this);
        return result;
    };
    return MailMergeOptions;
}());
exports.MailMergeOptions = MailMergeOptions;
